import { useEffect } from "react";
import { useHistory } from "react-router";

//STYLES
import { ContainerDefault } from "./styles";

//APP
import { useLogic } from "../../../context/useLogic";

//COMPONENT
import { TitleH1 } from "../titleH1";

//PROPS
interface Props {
    /**título da página */
    title: string;
    /**se possuir valor irá exigir selecionar uma safra no header principal */
    id_safra?: string;
    /**Conteúdo do módulo */
    children: React.ReactNode;
}

/**Componente padrão para módulo/página  */
export const DefautContainer: React.FC<Props> = ({ children, title, id_safra }) => {

    //CONST
    const { checkSafra } = useLogic();
    const history = useHistory();

    useEffect(() => {
        if (!!id_safra) {
            const idDaSafra = checkSafra(id_safra)
    
            if (!idDaSafra) {
            history.push('/home')
            }
        }
    }, [])

    return (
        <ContainerDefault>
            <div className="ContainerDefault__content">
                <div className="ContainerDefault__content__header">
                    <TitleH1>{title}</TitleH1>
                </div>
                <div className="ContainerDefault__content__children">
                    {children}
                </div>
            </div>
        </ContainerDefault>
    )
}